export class GooglePlaceAddress {
	private street: string = "";
	private streetNumber: string = "";
	private postCode: string = "";
	private city: string = "";
	private state: string = "";
	private country: string = "";
	private countryISO: string = "";

	public getStreet(): string {
		return this.street;
	}

	public getStreetNumber(): string {
		return this.streetNumber;
	}

	public getPostCode(): string {
		return this.postCode;
	}

	public getCity(): string {
		return this.city;
	}

	public getState(): string {
		return this.state;
	}

	public getCountry(): string {
		return this.country;
	}

	public getCountryISO(): string {
		return this.countryISO;
	}

	public setStreet(s: string): void {
		this.street = s;
	}

	public setStreetNumber(streetNumber: string): void {
		this.streetNumber = streetNumber;
	}

	public setPostCode(s: string): void {
		this.postCode = s;
	}

	public setCity(s: string): void {
		this.city = s;
	}

	public setState(s: string): void {
		this.state = s;
	}

	public setCountry(s: string): void {
		this.country = s;
	}

	public setCountryISO(s: string): void {
		this.countryISO = s;
	}
}
